// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.otpInput-module_row__JgccG {
    position: relative;
}

.otpInput-module_captureInput__IAykV {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    border: 0;
    background: transparent;
    color: transparent;
    caret-color: transparent;
    text-align: center;
    letter-spacing: 0;
    outline: none;
    cursor: text;
    opacity: 0;
    z-index: 2;
}

.otpInput-module_captureInput__IAykV:disabled {
    cursor: default;
}

.otpInput-module_box__T4kkn {
    position: relative;
    overflow: hidden;
}

.otpInput-module_accent__cBRAQ {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
}

.otpInput-module_caret__W8Y0A {
    animation: otpInput-module_otp-caret-blink__dh21o 1.06s step-end infinite;
}

@keyframes otpInput-module_otp-caret-blink__dh21o {
    0%,
    50% {
        opacity: 1;
    }
    50.01%,
    100% {
        opacity: 0;
    }
}
`, "",{"version":3,"sources":["webpack://./../../packages/consumer/src/widgets/Inputs/otpInput.module.css"],"names":[],"mappings":";AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,SAAS;IACT,UAAU;IACV,SAAS;IACT,uBAAuB;IACvB,kBAAkB;IAClB,wBAAwB;IACxB,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,YAAY;IACZ,UAAU;IACV,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,yEAAkD;AACtD;;AAEA;IACI;;QAEI,UAAU;IACd;IACA;;QAEI,UAAU;IACd;AACJ","sourcesContent":["\n.row {\n    position: relative;\n}\n\n.captureInput {\n    position: absolute;\n    inset: 0;\n    width: 100%;\n    height: 100%;\n    margin: 0;\n    padding: 0;\n    border: 0;\n    background: transparent;\n    color: transparent;\n    caret-color: transparent;\n    text-align: center;\n    letter-spacing: 0;\n    outline: none;\n    cursor: text;\n    opacity: 0;\n    z-index: 2;\n}\n\n.captureInput:disabled {\n    cursor: default;\n}\n\n.box {\n    position: relative;\n    overflow: hidden;\n}\n\n.accent {\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: 0;\n}\n\n.caret {\n    animation: otp-caret-blink 1.06s step-end infinite;\n}\n\n@keyframes otp-caret-blink {\n    0%,\n    50% {\n        opacity: 1;\n    }\n    50.01%,\n    100% {\n        opacity: 0;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"row": `otpInput-module_row__JgccG`,
	"captureInput": `otpInput-module_captureInput__IAykV`,
	"box": `otpInput-module_box__T4kkn`,
	"accent": `otpInput-module_accent__cBRAQ`,
	"caret": `otpInput-module_caret__W8Y0A`,
	"otp-caret-blink": `otpInput-module_otp-caret-blink__dh21o`
};
export default ___CSS_LOADER_EXPORT___;
